import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { useAuth, useApiPatch } from "../../../hooks";
import { SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";

import FuelRateForm from './FuelRateForm';

export default function UpdateFuelRate({ show, onHide, fuelRateDetails, handleAct}) {
    console.log('fuelRateDetails', fuelRateDetails);
    const recordId = fuelRateDetails?.id;
    const [submitted, setSubmitted] = useState(false);
    const [customerror, setCustomerror] = useState('');
    const { authToken } = useAuth();
  
    const { patchData, loading: updateLoading } = useApiPatch(`entities`, authToken);
  
  
    const handleSubmit = async (formData) => {
        setSubmitted(false);
      if (formData && Object.keys(formData).length > 0) {
        let formDataObj = {};
        formDataObj.id = recordId;
        formDataObj.fuelRate = formData;
        const payload = JSON.stringify(formDataObj);
        const { result, error } = await patchData(payload);
  
        if (result?.data) {
          setSubmitted(true);
          setTimeout(() => {
            handleAct();
          }, 200);
        } else {
          setCustomerror(error || 'Failed to update fuel rate');
        }
      }
    };

  return (<Modal role="dialog" className='fuelrateedit-form-popup' dialogClassName="right-slide-modal" size='lg' show={show} backdrop centered={false} >
            <div className="modal-content">
              <button type="button" onClick={onHide} className="btn-close position-absolute end-0 top-0 m-3"></button>
              <ModalHeader>Update Fuel Rate</ModalHeader>
                  <ModalBody>
  
                    <div className="fuelrateedit-page">
                      {/*submitted && <SuccessToolbar message="🎉 fuelrate have been updated successfully." />*/}
                      {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}
                      <FuelRateForm
                        mode="edit"
                        onSubmit={handleSubmit}
                        loading={updateLoading}
                        initialData={fuelRateDetails}
                      />
                    </div>
          
                </ModalBody>
             </div>
           </Modal>);
}